<template lang="html">
  <div class="navigation">
    <div>
      <ul class="nav">
          <li>
            <a :href="$store.state.index2_path">资讯</a>
          </li>
          <li>
            <a :href="$store.state.index2_path + '/Activity/activityList'">活动</a>
          </li>
          <li @click="change">
            <a :href="$store.state.index_path + '/mindex/specialList'">专题 <img :src="$store.state.static_img_url+'mobile/pic/pro.png'"></a>
          </li>
          <li @click="change">
            <a :href="$store.state.index2_path + '/home/liveList'">直播</a>
          </li>
          <li @click="change">
            <a :href="$store.state.index2_path + '/Book/buyBook'">动脉图书</a>
          </li>
          <li @click="change">
            <a href="https://vb100.vbdata.cn/">100强大会</a>
          </li>
          <li>
            <a :href="$store.state.index2_path + '/Index/Index/aboutUs'">关于我们</a>
          </li>
          <li class="case">
            <a class="case-title">解决方案
              <i v-if="case_icon" class="iconfont">&#xe63b;</i>
              <i v-else class="iconfont">&#xe648;</i>
            </a>
            <div class="nav-two">
              <div class="title">品牌宣传</div>
              <a :href="$store.state.index2_path + '/BrandCommunication'">品牌策划传播</a>
              <a :href="$store.state.index2_path + '/IndustrialResearch'">产业研究报告</a>
              <div class="title">项目合作</div>
              <a :href="$store.state.index2_path + '/IndustrialValueadded'">产业增值服务</a>
              <div class="title">企业直播</div>
              <a :href="$store.state.index2_path + '/VBopenclass'">动脉公开课</a>
              <a :href="$store.state.index2_path + '/ArterialRoadshowHall'">动脉路演厅</a>
              <div class="title">产业咨询服务</div>
              <a :href="$store.state.index2_path + '/IndustryConsultation'">战略规划/赛道遴选</a>
              <div class="title">数据服务</div>
              <a :href="$store.state.index_path + '/mindex/applyTest'">动脉橙机构版<span style="font-weight: bold">2.0</span></a>
            </div>
          </li>
      </ul>
      <ul class="change-main">
        <li><a href="http://i.vcbeat.top/">English</a></li>
        <li><a :href="$store.state.index2_path">中文</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      case_icon: false
    }
  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
      $('.case').on('click', '.case-title', function () {
        _this.case_icon = !_this.case_icon
        var _that = $(this).parents('li')
        _that.children('.nav-two').slideToggle(200);
        _that.toggleClass('on');
      });
    })
  },
  methods: {
    change() {
      this.$emit('change')
    }
  }
}
</script>
<style lang="stylus" scoped>
.change-main
  margin-top: .4rem
.nav
  overflow: auto
  flex-grow: 1
  li 
    a 
      font-weight: 100
      i 
        font-size .2rem
        color: #fff;  
        margin-left: 10px;
    .nav-two 
      font-size: .22rem;
      font-weight: 500;
      color: #D9D9D9;
      line-height: .28rem;
      display: none
      .title
        color: #FA5A00;
        margin-top .28rem
      a 
        display: block
        margin-top .28rem
</style>